const postMiniBrowserMessage = (message) => {
    const needsIframeBridge = !!navigator.userAgent.match(/MSIE|trident|edge/i);
    try {
        if (needsIframeBridge) {
            const bridge = (window.opener && window.opener.frames && window.opener.frames.PayPalBridge);
            if (bridge && bridge.returnToParent && message) {
                bridge.returnToParent(message);
            } else {
                throw new Error('Unable to post message via bridge');
            }
        } else if (window.opener && window.opener.postMessage && message) {
            window.opener.postMessage(message, '*');
        }
    } catch (e) {
        window.capeLog && window.capeLog('Error while trying to post message', e);
    }
};

export default postMiniBrowserMessage;
